import React__default from 'react';
import AppCheckbox from '../../app-checkbox/AppCheckbox.js';
import { ReactComponent as SvgWhatsappGreen } from '../../../icons/WhatsappGreen.svg.js';
import Styles from './PhoneNumForm.module.scss.js';
import classNames from 'classnames';
import { phoneNumModel } from './phoneNumModel.js';
import FlatInput from '../../flat-input/FlatInput.js';
import A from '../../app-anchor/A.js';
import { IDs } from '../../../constants/automation.js';

const PhoneNumForm = ({ onBlurPhoneNumField, isValid, formikConfig, className, watsAppCheckboxClassname }) => {
    const onChangeWACheckbox = (isChecked) => {
        formikConfig.setFieldValue(phoneNumModel.fields.whatsappUpdatesEnabled, isChecked);
    };
    const onChangePhoneNum = (e) => {
        e.target.value = e.target.value.slice(0, 10);
        formikConfig.handleChange(phoneNumModel.fields.phoneNum)(e);
    };
    const _onBlurPhoneNumField = () => {
        if (!formikConfig.values.phoneNum) {
            return;
        }
        onBlurPhoneNumField === null || onBlurPhoneNumField === void 0 ? void 0 : onBlurPhoneNumField();
    };
    return (React__default.createElement("div", { className: classNames(Styles.main, className) },
        React__default.createElement(FlatInput, { name: phoneNumModel.fields.phoneNum, type: "number", isActiveByDefault: true, isRequired: true, labelText: "Enter your mobile number", valuePrefix: "+91 -", value: String(formikConfig.values.phoneNum || ""), onChange: onChangePhoneNum, onBlur: _onBlurPhoneNumField, error: formikConfig.errors.phoneNum, isValid: isValid, containerStyles: {}, showValidationErrOnChange: false, id: IDs.auth.phoneNumber }),
        React__default.createElement("div", { className: classNames(Styles.whatsAppCheckbox, watsAppCheckboxClassname) },
            React__default.createElement(AppCheckbox, { labelText: "Get updates on", isChecked: !!formikConfig.values.whatsappUpdatesEnabled, onChange: onChangeWACheckbox, styles: {
                    fontWeight: "bolder",
                    width: "200px",
                    fontSize: "14px",
                    color: "#0D132D"
                }, labelClass: Styles.label, checkboxStyle: { width: "18px", height: "18px" } }),
            React__default.createElement("span", { className: Styles.whatsApp },
                React__default.createElement(SvgWhatsappGreen, null),
                "WhatsApp")),
        React__default.createElement("div", { className: classNames(Styles.termsAndCondition, watsAppCheckboxClassname) },
            React__default.createElement("span", null,
                "By signing up, you accept our",
                " ",
                React__default.createElement(A, { href: "/terms-and-conditions", openInNewTab: true }, "Terms of use"),
                " ",
                "and",
                " ",
                React__default.createElement(A, { href: "/privacy-policy", openInNewTab: true }, "Privacy Policy")))));
};

export { PhoneNumForm as default };
//# sourceMappingURL=PhoneNumForm.js.map
